import { fixAmazonS3Url } from '@/helpers/string';
import { Paginator, ServerStatus } from '@/models/globalModels';
import { Redemption, Reward, RewardsReducerPropsType, VaultItemBalance, VaultItemReward } from '@/models/rewardsModel';

import * as t from '../types';

const globalState: RewardsReducerPropsType = {
  rewardsStatus: ServerStatus.IDLE,
  redeemRewardStatus: ServerStatus.IDLE,
  redeemRewardHTTPStatusCode: undefined,
  lastRedeemedReward: undefined,
  vaultItemsRewardsStatus: ServerStatus.IDLE,
  redemptionDetailStatus: ServerStatus.IDLE,
};

export type PossibleActions =
  | { type: 'GET_REWARDS_FETCH'; payload: Paginator<Reward> }
  | { type: 'GET_REWARDS_FETCHING' }
  | { type: 'GET_REWARDS_FETCH_ERROR' }
  | { type: 'REDEEM_REWARD_IDLE' }
  | { type: 'REDEEM_REWARD_FETCHING' }
  | { type: 'REDEEM_REWARD_FETCH'; payload: Reward }
  | { type: 'REDEEM_REWARD_FETCH_ERROR'; payload: any }
  // V3 Rewards
  | { type: 'GET_VAULT_ITEMS_REWARDS_FETCH'; payload: Paginator<VaultItemReward> }
  | { type: 'GET_VAULT_ITEMS_REWARDS_FETCHING' }
  | { type: 'GET_VAULT_ITEMS_REWARDS_FETCH_ERROR' }
  | { type: 'GET_VAULT_ITEM_BALANCE_FETCH'; payload: VaultItemBalance }
  | { type: 'GET_VAULT_ITEM_BALANCE_FETCHING' }
  | { type: 'GET_VAULT_ITEM_BALANCE_FETCH_ERROR' }
  | { type: 'REDEEM_VAULT_ITEM_REWARD_IDLE' }
  | { type: 'REDEEM_VAULT_ITEM_REWARD_FETCHING' }
  | { type: 'REDEEM_VAULT_ITEM_REWARD_FETCH'; payload: VaultItemReward }
  | { type: 'REDEEM_VAULT_ITEM_REWARD_FETCH_ERROR'; payload: any }
  | { type: 'GET_REDEMPTION_DETAIL_FETCH'; payload: Redemption }
  | { type: 'GET_REDEMPTION_DETAIL_FETCHING' }
  | { type: 'GET_REDEMPTION_DETAIL_FETCH_ERROR' };

const reducer = (state = globalState, action: PossibleActions): RewardsReducerPropsType => {
  let results, redeemError;
  switch (action.type) {
    case t.GET_REWARDS_FETCHING:
      return {
        ...state,
        rewardsStatus: ServerStatus.FETCHING,
      };
    case t.GET_REWARDS_FETCH:
      results = action.payload.results.map((reward) => {
        return {
          ...reward,
          config: reward.config && typeof reward.config == 'string' ? JSON.parse(reward.config) : reward.config,
          image: reward.image ? fixAmazonS3Url(reward.image) : reward.image,
          pointsWrapped: [reward.points],
        };
      });

      return {
        ...state,
        rewardsStatus: ServerStatus.FETCH,
        rewards: { ...action.payload, results },
        //rewardsOptions: action.payload[1],
      };
    case t.GET_REWARDS_FETCH_ERROR:
      return {
        ...state,
        rewardsStatus: ServerStatus.FETCH_ERROR,
      };
    case t.REDEEM_REWARD_IDLE:
      return {
        ...state,
        redeemRewardStatus: ServerStatus.IDLE,
      };
    case t.REDEEM_REWARD_FETCHING:
      return {
        ...state,
        redeemRewardStatus: ServerStatus.FETCHING,
      };
    case t.REDEEM_REWARD_FETCH:
      const lastRedeemed = Object.assign({}, action.payload);
      return {
        ...state,
        redeemRewardStatus: ServerStatus.FETCH,
        lastRedeemedReward: lastRedeemed,
      };
    case t.REDEEM_REWARD_FETCH_ERROR:
      redeemError = Object.assign({}, action.payload);
      return {
        ...state,
        redeemRewardStatus: ServerStatus.FETCH_ERROR,
        redeemRewardErrorMsg: redeemError?.apiResponse?.data?.error,
        redeemRewardHTTPStatusCode: redeemError?.apiResponse?.request?.status,
      };
    case t.GET_VAULT_ITEMS_REWARDS_FETCHING:
      return {
        ...state,
        vaultItemsRewardsStatus: ServerStatus.FETCHING,
      };
    case t.GET_VAULT_ITEMS_REWARDS_FETCH:
      results = action.payload.results.map((vaultItem) => {
        return {
          ...vaultItem,
        };
      });

      return {
        ...state,
        vaultItemsRewardsStatus: ServerStatus.FETCH,
        vaultItemsRewards: { ...action.payload, results },
      };
    case t.GET_VAULT_ITEMS_REWARDS_FETCH_ERROR:
      return {
        ...state,
        vaultItemsRewardsStatus: ServerStatus.FETCH_ERROR,
      };
    case t.GET_VAULT_ITEM_BALANCE_FETCHING:
      return {
        ...state,
        vaultItemBalanceStatus: ServerStatus.FETCHING,
      };
    case t.GET_VAULT_ITEM_BALANCE_FETCH:
      const balance = Object.assign({}, action.payload);
      return {
        ...state,
        vaultItemBalanceStatus: ServerStatus.FETCH,
        vaultItemBalance: balance,
      };
    case t.GET_VAULT_ITEM_BALANCE_FETCH_ERROR:
      return {
        ...state,
        vaultItemBalanceStatus: ServerStatus.FETCH_ERROR,
      };
    case t.REDEEM_VAULT_ITEM_REWARD_IDLE:
      return {
        ...state,
        redeemVaultItemRewardStatus: ServerStatus.IDLE,
        redeemVaultItemRewardXRequestId: null,
      };
    case t.REDEEM_VAULT_ITEM_REWARD_FETCHING:
      return {
        ...state,
        redeemVaultItemRewardStatus: ServerStatus.FETCHING,
      };
    case t.REDEEM_VAULT_ITEM_REWARD_FETCH:
      const lastVaultRedeemed = Object.assign({}, action.payload);
      return {
        ...state,
        redeemVaultItemRewardStatus: ServerStatus.FETCH,
        // lastRedeemedReward: lastVaultRedeemed,
      };
    case t.REDEEM_VAULT_ITEM_REWARD_FETCH_ERROR:
      redeemError = Object.assign({}, action.payload);
      return {
        ...state,
        redeemVaultItemRewardStatus: ServerStatus.FETCH_ERROR,
        redeemRewardErrorMsg: redeemError?.apiResponse?.error,
        redeemVaultItemRewardXRequestId: redeemError?.xRequestId ?? null,
      };
    case t.GET_REDEMPTION_DETAIL_FETCHING:
      return {
        ...state,
        redemptionDetailStatus: ServerStatus.FETCHING,
      };
    case t.GET_REDEMPTION_DETAIL_FETCH:
      const redemption = Object.assign({}, action.payload);
      return {
        ...state,
        redemptionDetailStatus: ServerStatus.FETCH,
        redemption: redemption,
      };
    case t.GET_REDEMPTION_DETAIL_FETCH_ERROR:
      return {
        ...state,
        redemptionDetailStatus: ServerStatus.FETCH_ERROR,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
